import { GetApp } from "../../App"
import { classNames } from "../../Components"
import { DayViewData, dayToDate } from "./Context"
import { BlankDayViewProps } from "./Params"

export function BlankDayView({ day }: BlankDayViewProps) {
  const app = GetApp()!;
  const date = dayToDate(day.day);
  return (
    <div className={classNames(["DayView", "blank", DayViewData.isWeekend(date) && "highlight-weekend", DayViewData.monthHighlight(date) && "highlight-month"])}>
      <div className="DayHeaderView">
        <div className="DayView-date">{app.format("dateInYear", date.toISOString())}</div>
        <div className="DayView-timeline">
          <div className="hour hour-12"></div>
        </div>
        <div className="DayView-cell DayView-comment"></div>
        <div className="DayView-cell DayView-duration"></div>
        <div className="DayView-cell DayView-speed"></div>
        <div className="DayView-cell DayView-distance"></div>
        <div className="DayView-gap"></div>
      </div>
    </div>
  );
}
